export default {"src":"/_next/static/media/icon_times-close.412d85bc.svg","height":512,"width":352};